import React, { useState } from "react";
import styles from "./AdminCentralCommandScreen.module.css";
import { Dropdown, TextComponent } from "../../../components";
import { List, Table } from "antd";
import BarChart from "../AdminDashboard/BarChart/BarChart";
import { BsThreeDots } from "react-icons/bs";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";
import { t } from "i18next";
import HeaderComponent from "../../../components/HeaderComponent/HeaderComponent";

const AdminCentralCommandScreen = () => {
  const OverviewData = [
    {
      OrderID: 123,
      Department: "Today’s Tasks",
      StartTime: "11:25 pm",
      EndTime: "11:25 pm",
      OrderStatus: "In Progresss",
      color: "#C6450C",
    },
    {
      OrderID: 233,
      Department: "Today’s Tasks",
      StartTime: "11:25 pm",
      EndTime: "11:25 pm",
      OrderStatus: "In Progresss",
      color: "#F37E43",
    },
    {
      OrderID: 233,
      Department: "Today’s Tasks",
      StartTime: "11:25 pm",
      EndTime: "11:25 pm",
      OrderStatus: "In Progresss",
      color: "#AB3006",
    },
    {
      OrderID: 233,
      Department: "Today’s Tasks",
      StartTime: "11:25 pm",
      EndTime: "11:25 pm",
      OrderStatus: "In Progresss",
      color: "#C74D52",
    },
    {
      OrderID: 233,
      Department: "Today’s Tasks",
      StartTime: "11:25 pm",
      EndTime: "11:25 pm",
      OrderStatus: "In Progresss",
      color: "#822D12",
    },
  ];

  const renderOverview = (item, index) => {
    return (
      <div
        className={styles.rj_listItem}
        style={{
          backgroundColor: item?.color,
        }}
      >
        <div className={styles.Mini_Row}>
          <TextComponent text={"Order ID"} className={styles.CardText} />
          <TextComponent text={item?.OrderID} className={styles.CardText} />
        </div>
        <div className={styles.Mini_Row}>
          <TextComponent text={"Department"} className={styles.CardText} />
          <TextComponent text={item?.Department} className={styles.CardText} />
        </div>
        <div className={styles.Mini_Row}>
          <TextComponent text={"Start Time"} className={styles.CardText} />
          <TextComponent text={item?.StartTime} className={styles.CardText} />
        </div>
        <div className={styles.Mini_Row}>
          <TextComponent
            text={"End Time"}
            className={styles.CardText}
            color={"--var(white-color)"}
            fontSize={"var(--mobile-sub-heading)"}
            padding={"0px"}
          />
          <TextComponent
            text={item?.EndTime}
            className={styles.CardText}
            fontSize={"var(--mobile-sub-heading)"}
            color={"--var(white-color)"}
            padding={"0px"}
          />
        </div>
        <div className={styles.Mini_Row}>
          <TextComponent
            text={"Order Status"}
            className={styles.CardText}
            color={"--var(white-color)"}
            fontSize={"var(--mobile-sub-heading)"}
            padding={"0px"}
          />
          <TextComponent
            text={item?.OrderStatus}
            className={styles.CardText}
            color={"--var(white-color)"}
            fontSize={"var(--mobile-sub-heading)"}
            padding={"0px"}
          />
        </div>
      </div>
    );
  };

  const [chartData, setChartData] = useState({
    labels: ["15%", "17%", "21%", "25%", "21%", "21%"],
    datasets: [
      {
        label: "Wheat",
        data: [15, 18, 7, 21, 25, 25],
        backgroundColor: [
          "#C74D52",
          "#FB9A68",
          "#C74D52",
          "#822D12",
          "#F39C12",
          "#AB3006",
        ],
        borderRadius: 10,
        borderColor: "transparent",
        barPercentage: 0.7,
        categoryPercentage: 0.5,
      },
    ],
  });

  const columns = [
    {
      title: "Role",
      dataIndex: "Role",
      key: "Role",
    },
    {
      title: "Mixing",
      dataIndex: "Mixing",
      key: "Mixing",
    },
    {
      title: "Assembly",
      dataIndex: "Assembly",
      key: "Assembly",
    },
    {
      title: "Make Up",
      key: "MakeUp",
      dataIndex: "MakeUp",
    },
    {
      title: "Proofing",
      key: "Proofing",
      dataIndex: "Proofing",
    },
    {
      title: "Oven",
      key: "Oven",
      dataIndex: "Oven",
    },
    {
      title: "Packaging",
      key: "Packaging",
      dataIndex: "Packaging",
    },
  ];
  const data = [
    {
      Role: "Staff Member",
      Mixing: "04",
      Assembly: "14",
      MakeUp: "13",
      Proofing: "13",
      Oven: "18",
      Packaging: "19",
    },
    {
      Role: "Supervisor",
      Mixing: "04",
      Assembly: "14",
      MakeUp: "13",
      Proofing: "13",
      Oven: "18",
      Packaging: "19",
    },
    // {
    //   Role: "Staff Member",
    //   Mixing: "04",
    //   Assembly: "14",
    //   MakeUp: "13",
    //   Proofing: "13",
    //   Oven: "18",
    //   Packaging: "19",
    // },
  ];

  const Colors = [
    "#C74D52",
    "#FB9A68",
    "#C74D52",
    "#822D12",
    "#F39C12",
    "#AB3006",
  ];

  const StatusOptions = [
    {
      value: "All",
      id: 1,
    },
    {
      value: "Scheduled",
      id: 2,
    },
    {
      value: "In Progress",
      id: 3,
    },
    {
      value: "Completed",
      id: 4,
    },
  ];

  const [SelectedStatus, setSelectedStatus] = useState({
    value: "Mixing",
    id: 1,
  });

  const Stations = [
    { value: "Mixing", id: 1 },
    { value: "Oven", id: 2 },
    { value: "Proof", id: 3 },
    { value: "Chill", id: 4 },
    { value: "Assembly", id: 5 },
    { value: "Packaging", id: 6 },
    { value: "Make Up", id: 7 },
  ];

  const [SelectedStation, setSelectedStation] = useState({
    value: "All",
    id: 1,
  });

  return (
    <div className={styles.mainCon}>
      <HeaderComponent heading={t("Central Command  Screen ")} />

      <div className={styles.SubMainCont}>
        <div className={styles.TaskFeedDiv}>
          <TextComponent
            text={t("Live Task Feed ")}
            className={styles.TaskFeedHeading}
          />
          <div>
               <TextComponent
               style={{marginTop:20}}
            text={t("Bread ")}
          />
            <List
              dataSource={OverviewData}
              renderItem={renderOverview}
              style={{ marginTop: 10 }}
              grid={{
                gutter: [0, 16],
                xs: 1,
                sm: 2,
                md: 3,
                lg: 5,
                xl: 5,
                xxl: 5,
              }}
            />
          </div>
              <div>
               <TextComponent
               style={{marginTop:20}}
            text={t("General patery")}
          />
            <List
              dataSource={OverviewData}
              renderItem={renderOverview}
              style={{ marginTop: 10 }}
              grid={{
                gutter: [0, 16],
                xs: 1,
                sm: 2,
                md: 3,
                lg: 5,
                xl: 5,
                xxl: 5,
              }}
            />
          </div>
        </div>

        <div>

                   <TextComponent
            text={t("Today’s Production Matrices")}
            className={styles.TaskFeedHeading}
          />
        </div>
    
      </div>
    </div>
  );
};

export default AdminCentralCommandScreen;
